/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Component } from 'react';
import { Button } from 'antd';
import colors from '../colors';

const STASH_KEY = 'GPS_impersonation_stash';

// Persistent top banner shown whenever a superadmin is impersonating another
// user (card #160). The original superadmin session (user + token) is stashed
// in localStorage under STASH_KEY when impersonation starts; Exit restores it.
export class ImpersonationBanner extends Component {
  getStash = () => {
    try {
      const raw = localStorage.getItem(STASH_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  exit = () => {
    const stash = this.getStash();
    localStorage.removeItem(STASH_KEY);
    const store = window.STORE;
    if (stash && stash.user && store) {
      // Restore the superadmin's own user + token.
      store.dispatch({ type: 'SET_CURRENT_USER', payload: stash.user });
      if (stash.user.token) {
        store.dispatch({ type: 'SET_TOKEN', token: stash.user.token });
      }
      // Persist directly so the reload re-hydrates the restored session.
      try {
        const persisted = JSON.parse(localStorage.getItem('persist:GPS_root') || '{}');
        persisted.user = JSON.stringify(stash.user);
        localStorage.setItem('persist:GPS_root', JSON.stringify(persisted));
      } catch (e) { /* fall back to dispatched state */ }
    }
    window.location.href = '/dashboard';
  }
  render() {
    const stash = this.getStash();
    if (!stash) return null;

    return (
      <div css={css`
        position: relative;
        z-index: 1000;
        background: ${colors.error};
        color: ${colors.white};
        padding: 8px 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      `}>
        <span>You are impersonating this user - {stash.impersonating}</span>
        <Button
          size="small"
          style={{ marginLeft: 16 }}
          onClick={this.exit}
        >
          Exit
        </Button>
      </div>
    );
  }
}

export default ImpersonationBanner;
